<header class="header"
        [ngClass]="{'fixedHeader':   isQuoteDetailsPage}">

    <a aria-label="123-home"
       class="header__logo"
       (click)="leaveSite()">
        <img ngSrc="./assets/images/123.svg"
             width="79"
             height="24"
             alt="123-logo"
             priority>
    </a>

    @if(isQuoteDetailsPage && isExcessAfterFirstStepQuote && quotePrice){
    <div class="header_Price_Icon">
        <span class="currency-amt">{{ quotePrice }}</span>
    </div>

    }
</header>